export default __webpack_public_path__ + "0795351093b4660b2c65fe07747c34be.jpg";